import styled from 'styled-components'

import { down, up } from '@Globals/Style/breakpoints'

interface FooterElementProps {
  topBorderBottomColor?: string
}

export const FooterElement = styled.div<FooterElementProps>`
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 20px;

  ${up('tablet')} {
    width: calc(50% - 30px);
    padding: 0 0 15px;
  }


  ${up('desktop')} {
    width: calc(33.33% - 20px);
    padding: 0 0 15px;
  }

  ${down('phablet')} {
    flex: 0 0 100%;
  }

  &.top {
    border: none;
    ${up('desktop')} {
      border-bottom: 1px solid ${({ theme, topBorderBottomColor }) => topBorderBottomColor
      ?? theme.colors.grey};
    }
  }

  .container {
    display: flex;
    flex-wrap: wrap;

    .row {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
      min-height: 24px;

      .link, .itemText {
        margin-left: 10px;
      }

      .link a {
        display: block;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`

export const SectionTitle = styled.div`
  color: ${({ theme }) => theme.colors.greyDark};
  width: 100%;
  padding-bottom: 15px;
  font-weight: 700;
  font-size: 1.125rem;
  text-transform: uppercase;
`

export const Text = styled.p`
  padding-bottom: 10px;
`
